import { Auth0Client } from '@auth0/auth0-spa-js';

const initAuth0 = () => {
  if (process.env.BUILD_ENV === 'STORYBOOK' || typeof window === 'undefined') {
    return {
      async getTokenSilently() {
        return 'faketoken';
      },
      async getUser() {
        return {
          name: 'Jane Doe',
        };
      },
    };
  }

  return new Auth0Client({
    clientId: process.env.NEXT_PUBLIC_CLIENT_ID,
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/callback`,
      audience: 'https://flexbpoplafform.us.auth0.com/api/v2/',
      connection: process.env.NEXT_PUBLIC_AUTH0_CONNECTION,
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
  });
};

export default initAuth0();
